import { ReactElement } from 'react'

export const LoadingSpinner: ReactElement = (
  <div className="spinner">
    <i className="fa fa-spinner fa-spin" />
    Loading...
  </div>
)
